module.exports = __webpack_public_path__ + "img/pump-soap.a8868ec3.svg";